import React from 'react';
import PropTypes from 'prop-types';

const SvgSendBack = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#ffffff';
    const strokeColor = active ? '#ffffff' : '#343A72';
    const color = active ? '#7AB3B3' : '#9A9DB6';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <path
                fill={fillColor}
                stroke={strokeColor}
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m10.411 7.585 9.411 4.61-9.41 4.61L1 12.195l9.411-4.61Z"
            />
            <path
                fill={color}
                stroke={strokeColor}
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m10.411 1 9.411 4.61-9.41 4.61L1 5.61 10.411 1Z"
            />
            <path
                fill={strokeColor}
                stroke={strokeColor}
                strokeLinejoin="round"
                d="M17.805 24.708V18.25l1.795 1.8c3.88-3.894 4.904-9.178 2.286-11.806 4.19 4.206 4.44 10.767.56 14.661l1.797 1.803h-6.438Z"
            />
        </svg>
    );
};
SvgSendBack.propTypes = {
    active: PropTypes.bool,
};
SvgSendBack.defaultProps = {
    active: false,
};

export default SvgSendBack;
